import { apiClient } from './apiClient';
import type { PublisherDto, PagedResultDto } from '../types/publisher';

/**
 * Get list of active publishers for dropdown
 */
export async function getActivePublishers(): Promise<PublisherDto[]> {
  const response = await apiClient.get<PagedResultDto<PublisherDto>>(
    '/api/app/publishers',
    {
      params: {
        maxResultCount: 1000, // Fetch all publishers (up to 1000)
        isActive: true, // Filter only active publishers
        sorting: 'Name ASC' // Sort by name
      }
    }
  );
  return response.data.items;
}

/**
 * Get paginated list of all publishers
 */
export async function getPublishers(params?: {
  skipCount?: number;
  maxResultCount?: number;
}): Promise<PagedResultDto<PublisherDto>> {
  const response = await apiClient.get<PagedResultDto<PublisherDto>>(
    '/api/app/publishers-extn',
    { params }
  );
  return response.data;
}
